export enum WidgetType {
  chat = 'chat',
  fb = 'fb',
  cb = 'cb',
  cip = 'cip',
  cmt = 'cmt',
  ctt = 'ctt',
  ce = 'ce',
}
